import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';

import { AuthService } from '../services/auth.service';

// Gate a route on a live session. Awaits the session's hydration first — synchronous for localStorage, but kept so the
// gate reads the same way whatever backs the store — then sends an unauthenticated producer to the landing page.
// NOTE (Phase C/E): preserving the attempted URL for a post-sign-in return lands with the onboarding/deep-link work.
export const authGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);
  const router = inject(Router);
  await authService.awaitReady();
  return authService.isAuthenticated() ? true : router.createUrlTree(['/landing']);
};

export const authChildGuard: CanActivateChildFn = async () => {
  const authService = inject(AuthService);
  const router = inject(Router);
  await authService.awaitReady();
  return authService.isAuthenticated() ? true : router.createUrlTree(['/landing']);
};

// The inverse: keep an already-signed-in producer off the public entry pages.
export const loggedInGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);
  const router = inject(Router);
  await authService.awaitReady();
  return !authService.isAuthenticated() || router.createUrlTree(['/dashboard']);
};
